import React from 'react';
/**
 * `InputLabel` renders a standard HTML `<label>` for form inputs.
 *
 * It binds `htmlFor` to the provided `name` and sets `aria-label` to
 * `labelText` to support assistive technologies.
 */
export type InputLabelProps = {
  name: string;
  labelText: string;
  className?: string;
};

const InputLabel = ({
  name,
  labelText,
  className = ''
}: InputLabelProps): JSX.Element => {
  return (
    <label className={className} aria-label={labelText} htmlFor={name}>
      {labelText}
    </label>
  );
};

export default InputLabel;
